import { render, staticRenderFns } from "./StorageRoomShipmentRuleModal.vue?vue&type=template&id=41a56237"
import script from "./StorageRoomShipmentRuleModal.vue?vue&type=script&lang=js"
export * from "./StorageRoomShipmentRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports